export default __webpack_public_path__ + "static/Resizing-bc9028fb458d3ef16dba01ff3a77f4d9.mp4";